import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../../../utils/constants'
import apiService from '../../../utils/helpers/apiService'
import { IDomain } from '../../../types/resumeType'
import { AxiosResponse } from 'axios'

const useDomains = () => {
  const response = useQuery([queryKeys.domains], {
    queryFn: () =>
      apiService.get({
        url: '/matching/trained-job/',
        withToken: false,
      }) as Promise<AxiosResponse<IDomain[]>>,
  })

  return response
}

export default useDomains
